/**
 * Axios config for cross-origin API calls that forward the ts_anon_id cookie (TIM-309).
 * Use for any backend that reads anonymousId from server-side tracking context.
 */
export const withCredentialsConfig = { withCredentials: true };

/** @deprecated Use withCredentialsConfig */
export const legacyJetlagApiConfig = withCredentialsConfig;
